import React, { Children } from 'react';
import { DropTarget } from 'react-dnd';
import PropTypes from 'prop-types';

import { withStyles } from '@glu/theming';
import { JSSClasses } from '../../proptypes/jss-prop-types';

/* istanbul ignore next */
const styles = ({
  palette: {
    primary: { normal }
  },
  spacing: { unit }
}) => ({
  droppable: {
    position: 'relative',
    '&:after': {
      position: 'absolute',
      top: 0,
      left: 0,
      width: `calc(100% - ${unit * 2.25 * 2}px)`,
      height: '100%',
      content: '""',
      margin: `0 ${unit * 2.5}px`,
      border: `${normal} dashed ${unit / 4}px`
    }
  },
  heightFill: {
    height: `calc(100% - ${unit * 2.25 * 2}px)`,
    margin: `${unit * 2.25}px 0`
  },
  wrapper: {
    width: '100%'
  }
});

export function DroppableWorkspaceSectionComponent({
  children,
  classes: { droppable, heightFill, wrapper },
  connectDropTarget,
  id,
  isHovered
}) {
  const droppableClass = isHovered ? droppable : '';
  const heightClass = !Children.count(children) || isHovered ? heightFill : '';
  return connectDropTarget(
    <div className={wrapper}>
      <div id={id} className={`${droppableClass} ${heightClass}`}>
        {children}
      </div>
    </div>
  );
}

/* istanbul ignore next */
const target = {
  drop(props) {
    return {
      ...props,
      dropRow: props.row
    };
  }
};

/* istanbul ignore next */
const collect = (connect, monitor) => ({
  connectDropTarget: connect.dropTarget(),
  isHovered: monitor.isOver()
});

DroppableWorkspaceSectionComponent.defaultProps = {
  classes: {},
  isHovered: false
};

DroppableWorkspaceSectionComponent.propTypes = {
  className: JSSClasses,
  connectDropTarget: PropTypes.func.isRequired,
  isHovered: PropTypes.bool,
  row: PropTypes.number.isRequired
};

const styled = withStyles(styles)(DroppableWorkspaceSectionComponent);
export default DropTarget('WIDGET', target, collect)(styled);
